const MOBILE_BREAKPOINT = 768;

const getOnboardViewport = (width) => {
  if (typeof width === "number" && !Number.isNaN(width)) {
    return width < MOBILE_BREAKPOINT;
  }

  if (typeof window !== "undefined") {
    return window.innerWidth < MOBILE_BREAKPOINT;
  }

  return false;
};

export default getOnboardViewport;
